import { useEffect, useRef } from 'react';
import selectors from '@/redux/selectors/selectors';
import Spinner from '../Spinner.jsx';
import setPref from '@/redux/actions/uiActions/setPref.js';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';

const PlatformLoader = () => {
  const platformLoading = useArgSelector(selectors.pref, 'platformLoading');
  const { isLoading = false, message = '', showSpinner = true, showBeforeUnloadWarning = true } = platformLoading || {};
  const firstLoadingRef = useRef(platformLoading);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isLoading && showBeforeUnloadWarning) {
        e.preventDefault();
        e.returnValue = 'The app is still loading. Are you sure you want to leave?';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isLoading, showBeforeUnloadWarning]);

  // On initial load, make sure we aren't stuck on loading state from last page refresh.
  useEffect(() => {
    if (firstLoadingRef.current?.isLoading === true) {
      setPref('platformLoading', { isLoading: false });
    }
  }, []);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="platform-loader">
      <div className="content">
        {showSpinner && <Spinner size={24} />}
        <p>{message}</p>
      </div>
    </div>
  );
};

export default PlatformLoader;
